import React from 'react';
import ThemableSvgIcon from "../theme/ThemableSvgIcon";

function InfoBox(props) {
    return (
        <div className={`bg-grey-lighter p-4 ${props.classes ? props.classes : ""}`}>
            <div className="flex">
                <ThemableSvgIcon name={props.icon || "info-inverted"} className={`shrink-0 w-6 h-6 ${props.iconColorClass || "text-primary-dark"}`}/>
                <div className="ml-2 text-left leading-normal">
                    {props.infoText}
                </div>
            </div>
            {props.description &&
            <div className="mt-2">
                {props.description}
            </div>
            }
            {props.children &&
                props.children
            }
        </div>
    )
}

export default InfoBox;

